import React, { Component } from 'react';
import ImageCropper from './ImageCropper'
import Loader from './Loader.js';
import {merge} from 'lodash'
import { compose } from 'recompose';
import toastr from 'toastr';
import Select from 'react-select';
import ReactDragListView from 'react-drag-listview';
import { withFirebase } from '../firebase';
import * as ROUTES from '../constants/routes';
import {
  ADMIN_INPUT_DATA,
  INSTORE_INPUT_DATA,
  VOTE_INPUT_DATA,
  INPUT_DATA
  } from '../constants/form_config';
import {slugify} from '../utils.js'
const qs = require('query-string');

const initializeState = () => {
  let st = {
    uid: '',
    name: '',
    userId: '',
    createDate: 0,
    type: 'connectivity',
    body: '',
    logo: '',
    code: '',
    personal: 'No',
    phoneNum: '',
    facebook: '',
    twitter: '',
    instagram: '',
    youtube: '',
    google: '',
    pinterest: '',
    snapchat: '',
    website: '',
    website2: '',
    website3: '',
    websitename: '',
    website2name: '',
    website3name: '',
    Audio_barcode: '',
    ABOUT_ME: '',
    extraImage: '',
    extraImage2: '',
    extraImage3: '',
    extraImagename: '',
    extraImage2name: '',
    extraImage3name: '',
    error: null,
    showalldeals: 'No',
    saving: false,
    localMultimediaData: {},
    // Vote fields
    option1: '',
    option2: '',
    option3: '',
    option4: '',
    option5: '',
    // In store fields
    inPhoneNum: '',
    textScreen3: '',
    // Admin only fields
    textToShare: '',
    coupon: '',
    personID: '',
    sendEmail: '',
    premium: '',
    ownerCanManageMedia: 'Yes',
    // Downloadable media
    downloadable_media: [],
    // State
    sona_id_ok: true,
    media_thumb_upload: null,
    media_uploading: false,
    user_options: []
  }
  return st
}

const selectStyle = {
  option: (provided, state) => ({
    ...provided,
    color: 'black',
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return { ...provided, opacity, transition };
  }
}

export class CreateEditFormBase extends Component {
  constructor(props) {
    super(props);
    let st = initializeState()
    let populate = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).populate
    if (populate != null) merge(st, JSON.parse(populate))
    this.state = st

    this.cropChange = this.cropChange.bind(this)
    this.onAudioSelected = this.storeLocalFileInput.bind(this)
    this.onImageSelected = this.onImageSelected.bind(this)
    this.onDMImageSelected = this.storeLocalFileInput.bind(this)
    this.checkIDUnique = this.checkIDUnique.bind(this)
    this.uploadMediaToFirebase = this.uploadMediaToFirebase.bind(this)
    this.deleteMediaItem = this.deleteMediaItem.bind(this)
    this.generateQRCodeURL = this.generateQRCodeURL.bind(this)
    this.fetchUserOptions = this.fetchUserOptions.bind(this)
    this.handleUserSelection = this.handleUserSelection.bind(this)
    this.handleMediaReorder = this.handleMediaReorder.bind(this)

    // Refs
    this.dmFileInput = null
  }

  componentDidMount() {
    let {edit_sona_id} = this.props
    if (edit_sona_id != null) {
      // edit_sona_id will be the primary key (which is a name str currently)
      // Should be changed to code
      this.props.firebase
        .sona(edit_sona_id).once('value', snapshot => {
          let st = snapshot.val()
          st.uid = edit_sona_id
          merge(st, st.urls)
          delete st.urls
          this.setState(st)
        });
    }
  }

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onSubmit = event => {
    let valid = this.validate()
    if (valid) {
      this.getCodeMergeAudioAndSaveSONA()
    } else {
      console.log("Required fields missing")
      toastr.error("Required fields missing")
    }
    event.preventDefault();
  };

  onImageSelected = event => {
    let file = event.target.files[0];
    this.loadImageLocally(file, event.target.name)
    event.preventDefault();
  };

  storeLocalFileInput = event => {
    let file = event.target.files[0];
    let {localMultimediaData} = this.state
    if (!localMultimediaData) localMultimediaData = {}
    if (!localMultimediaData[event.target.name]) {
      localMultimediaData[event.target.name] = {}
    }
    localMultimediaData[event.target.name].file = file
    this.setState({localMultimediaData})
    event.preventDefault();
  }

  cropChange(prop, crop) {
    let {localMultimediaData} = this.state
    localMultimediaData[prop].crop = crop
    this.setState({localMultimediaData})
  }

  loadImageLocally(file, prop) {
    // Load data from file input and save into state
    let {localMultimediaData} = this.state
    if (file != null) {
      console.log(file)
      let FR = new FileReader();
      FR.addEventListener("load", (e) => {
        if (!localMultimediaData[prop]) {
          localMultimediaData[prop] = {}
        }
        localMultimediaData[prop].data = e.target.result
        localMultimediaData[prop].filename = file.name
        localMultimediaData[prop].file = file
        this.setState({localMultimediaData})
      });
      FR.readAsDataURL( file );
    }
  }

  generateQRCodeURL() {
    let {code, logo} = this.state
    const params = {
      auth: '5LgdMbRQacz5XMrhFCxR',
      code: code,
      logo_url: logo != null && logo.length > 0 ? this.gcsUrl(logo) : null
    }
    var qs = Object.keys(params).map(key => key + '=' + params[key]).join('&');
    return 'https://firebase-sonad.appspot.com/api/generate_qr?' + qs
  }

  removeImage(name) {
    console.log(`removing ${name}`)
    let {localMultimediaData} = this.state
    let st = {}
    // Clear image value
    st[name] = ''
    // If localMultimediaData, remove
    if (localMultimediaData[name] != null) {
      delete localMultimediaData[name]
      st.localMultimediaData = localMultimediaData
    }
    this.setState(st)
  }

  validate() {
    // Separately validate logo to support editing case (where file input not filled, but we have logo data)
    let {logo, localMultimediaData} = this.state
    let logoData = localMultimediaData['logo'] || {}
    if ((logo != null && logo.length > 0) || logoData.file != null) return true
    else return false
  }

  getActions() {
    let actions = 's'
    const { phoneNum, type,
            instagram, twitter, facebook, youtube, google, pinterest, snapchat,
            website, website2, website3,
            extraImage, extraImage2, extraImage3, option1, option2, option3, option4, option5,
            sendEmail } = this.state;
    if (type === 'Vote') {
      let opts = [option1, option2, option3, option4, option5];
      opts.forEach((op, idx) => {
        if (op != null && op.length > 0) actions += (idx+1).toString()
      })
    } else {
      if (instagram.length > 0) actions += 'I'
      if (twitter.length > 0) actions += 'T'
      if (facebook.length > 0) actions += 'F'
      if (youtube.length > 0) actions += 'Y'
      if (google.length > 0) actions += 'G'
      if (pinterest.length > 0) actions += 'P'
      if (snapchat.length > 0) actions += 'S'
      if (phoneNum.length > 0) actions += 'c'
      if (website.length > 0) actions += 'w'
      if (website2.length > 0) actions += 'y'
      if (website3.length > 0) actions += 'z'
      if (extraImage.length > 0) actions += 'x'
      if (extraImage2.length > 0) actions += 'u'
      if (extraImage3.length > 0) actions += 'v'
      if (sendEmail.length > 0) actions += 'e'
    }
    return actions;
  }

  getUIDNameSlug() {
    // Generate Sona ID as slug of name
    let {name} = this.state
    return slugify(name).substring(0, 30)
  }

  checkIDUnique() {
    let {sona_id_ok} = this.state
    let uid = this.getUIDNameSlug()
    if (uid != null && uid.length > 0) {
      this.props.firebase.sona(uid).once('value', snapshot => {
        let available = !snapshot.exists()
        if (available) {
          if (!sona_id_ok) {
            this.setState({sona_id_ok: true, uid: uid}, () => {
              toastr.success("SONA ID OK")
            })
          } else {
            this.setState({uid: uid})
          }
        } else {
          this.setState({sona_id_ok: false}, () => {
            toastr.error(`There is already a SONA with this unique ID (${uid}), please edit the name`);
          })
        }
      })
    }
  }

  getCodeMergeAudioAndSaveSONA() {
    const AUTH = '5LgdMbRQacz5XMrhFCxR' // TODO
    let {localMultimediaData, code} = this.state
    var data = new FormData();
    ['User_clip', 'logo', 'extraImage', 'extraImage2', 'extraImage3'].forEach((media_key) => {
      let input = localMultimediaData[media_key]
      if (input != null) {
        data.append(media_key, input.file)
        if (input.crop != null) data.append(media_key + '_crop', input.crop || '')
      }
    })
    data.append('auth', AUTH)
    if (code != null && code.length > 0) data.append('code', code)
    this.setState({saving: true}, () => {
      fetch('https://firebase-sonad.appspot.com/api/generate', {
        method: 'POST',
        body: data
      }).then(response => response.json()).then(res => {
        console.log(res)
        if (res.success && res.code) {
          this.setState(res.multimedia, () => {
            this.saveSONAToFirebase(res)
          })
        }
      }).catch(
        error => console.log(error) // Handle the error response object
      );
    })
  }

  saveSONAToFirebase(res) {
    const { uid, name, type, body, phoneNum, logo,
            facebook, twitter, instagram, youtube,
            google, pinterest, snapchat,
            websitename, website2name, website3name,
            website, website2, website3, personal,
            extraImage, extraImage2, extraImage3,
            Audio_barcode, ABOUT_ME, showalldeals,
            option1, option2, option3, option4, option5,
            inPhoneNum, textScreen3,
            extraImagename, extraImage2name, extraImage3name,
            textToShare, coupon, personID, sendEmail, premium,
            downloadable_media, ownerCanManageMedia
             } = this.state;
    let createDate = this.state.createDate
    let userId = this.state.userId
    console.log("Saving SONA to Firebase...")
    if (uid == null || uid.length === 0) {
      alert("Problem saving SONA, no uid")
      return
    }
    const sonaRef = this.props.firebase.sona(uid)
    if (this.editing()) {
      // No update to userId
    } else {
      // New
      userId = this.props.firebase.get_uid()
      createDate = new Date().getTime()
    }
    let sonaObj = {
        code: res.code,
        createDate: createDate,
        userId: userId,
        name: name,
        body: body,
        type: type,
        urls: {
          facebook: facebook,
          twitter: twitter,
          instagram: instagram,
          youtube: youtube,
          google: google,
          pinterest: pinterest,
          snapchat: snapchat,
          website: website,
          website2: website2,
          website3: website3,
          phoneNum: phoneNum
        },
        actions: this.getActions(),
        websitename: websitename,
        website2name: website2name,
        website3name: website3name,
        extraImage: extraImage,
        extraImagename: extraImagename,
        extraImage2: extraImage2,
        extraImage2name: extraImage2name,
        extraImage3: extraImage3,
        extraImage3name: extraImage3name,
        showalldeals: showalldeals,
        personal: personal,
        logo: logo,
        Audio_barcode: Audio_barcode || null,
        ABOUT_ME: ABOUT_ME || null,
        downloadable_media: downloadable_media,
        textToShare: textToShare,
        coupon: coupon,
        personID: personID,
        sendEmail: sendEmail,
        premium: premium,
        ownerCanManageMedia: ownerCanManageMedia
      }
    if (type === 'Vote') {
      if (option1.length > 0) sonaObj.urls.option1 = option1
      if (option2.length > 0) sonaObj.urls.option2 = option2
      if (option3.length > 0) sonaObj.urls.option3 = option3
      if (option4.length > 0) sonaObj.urls.option4 = option4
      if (option5.length > 0) sonaObj.urls.option5 = option5
    }
    if (type === 'In-Store') {
      if (inPhoneNum.length > 0) sonaObj.urls.inPhoneNum = inPhoneNum
      if (textScreen3.length > 0) sonaObj.urls.textScreen3 = textScreen3
    }
    sonaRef.set(sonaObj)
      .then(() => {
        const RELOAD_ON_SAVE = true;
        if (RELOAD_ON_SAVE) {
          if (!this.editing()) {
            // New, goto edit page
            this.props.history.push(`/edit/${uid}`);
          } else {
            window.location.reload()
          }
        } else {
          // Go home
          let st = initializeState()
          this.setState(st, () => {
            this.props.history.push(ROUTES.HOME);
          })
        }
      });
  }

  gcsUrl(url) {
    return 'https://storage.googleapis.com/' + url
  }

  universalShareURL() {
    let {code} = this.state
    let link = `https%3A%2F%2Fsonad%2Efirebaseapp%2Ecom%2Fsona%2F${code}`
    let url = `https://sonad.page.link/?ibi=com%2ESonad%2ESonad&isi=1090538431&apn=com%2Eapp%2Esonad%2Esonad&link=${link}`
    return url
  }

  fetchUserOptions() {
    let have_options = this.state.user_options.length > 0
    if (!have_options) {
      this.props.firebase.users().once('value').then((snapshot) => {
        let data = snapshot.val()
        let users = []
        Object.keys(data).forEach((key) => {
          if (key.indexOf('*') === -1) {
            let user = data[key]
            users.push({
              label: user.email,
              value: key
            })
          }
        })
        console.log(`Fetched ${users.length} user options from datastore`)
        this.setState({user_options: users})
      })
    }
  }

  handleUserSelection(form_key, op, action) {
    if (action.action === "select-option") {
      this.setState({ [form_key]: op.value });
    }
  }

  renderInputRows() {
    let {localMultimediaData, type, user_options} = this.state
    let {admin} = this.props
    const VOTE_NOT_REQ = ['phoneNum', 'body']
    let input_data = INPUT_DATA;
    if (type === 'Vote') {
      input_data = INPUT_DATA.filter((g) => g.show_for_vote)
      input_data = input_data.concat(VOTE_INPUT_DATA)
    } else if (type === 'In-Store') input_data = input_data.concat(INSTORE_INPUT_DATA)
    if (admin) input_data = input_data.concat(ADMIN_INPUT_DATA)
    return input_data.map((input_group) => {
      let inputs = input_group.items.map((input_object) => {
        let input_el, lookup_el
        let value = this.state[input_object.name] || ''
        let attrs = input_object.attrs || {}
        let locked = input_object.locked || false
        let required = input_object.required
        if (type === 'Vote' && (VOTE_NOT_REQ.indexOf(input_object.name) > -1)) required = false
        let changeHandler = this.onChange
        if (input_object.type === 'select') {
          input_el = (
            <select
                  name={input_object.name}
                  value={value}
                  onChange={changeHandler}
                  {...attrs}
                  required={required}
            >
            { input_object.options.map((op) => {
              return <option key={op.value} value={op.value}>{op.label}</option>
            })}
            </select>
          )
        } else if (input_object.type === 'textarea') {
          let sona_name_input = input_object.name === 'name'
          if (sona_name_input && !this.editing()) {
            attrs.onBlur = this.checkIDUnique
          }
          input_el = <textarea type={input_object.type}
                        name={input_object.name}
                        value={value}
                        placeholder={input_object.label}
                        onChange={changeHandler}
                        required={required}
                        autoComplete="off"
                        {...attrs}
                  />
        } else {
          let preview, remove
          if (input_object.changeHandler === 'image') {
            changeHandler = this.onImageSelected
          } else if (input_object.changeHandler === 'audio') {
            changeHandler = this.onAudioSelected
          }
          if (input_object.type === 'file') {
            let cropper
            let localData = localMultimediaData[input_object.name]
            if (value.length > 0) {
              // Preview image/audio
              if (input_object.changeHandler === 'image') {
                preview = <img className='avatarPreview' src={this.gcsUrl(value)} alt={localData != null ? localData.filename : ''} />
                // Add remove link for all images besides logo (which is required)
                if (input_object.name !== 'logo') remove = (
                  <div>
                    <a href="javascript:void(0)" onClick={this.removeImage.bind(this, input_object.name)}>Remove image</a>
                  </div>
                )
              } else {
                // Audio
                preview = <audio controls src={this.gcsUrl(value)} />
              }
            }
            if (input_object.changeHandler === 'image') {
              if (localData != null && localData.file != null) {
                cropper = <FirebaseImageCropper image_data={localData.data}
                                                prop={input_object.name}
                                                file={localData.file}
                                                cropChange={this.cropChange} />
              }
            }
            value = ''
            input_el = (
              <div>
                <input type={input_object.type}
                        name={input_object.name}
                        placeholder={input_object.label}
                        onChange={changeHandler}
                        required={required}
                        autoComplete="off"
                        disabled={locked}
                        {...attrs}
                  />
                  { cropper }
                  { preview }
                  { remove }
              </div>
            )
          } else {
            // Not file input (standard text input)
            input_el = <input type={input_object.type}
                          name={input_object.name}
                          value={value}
                          placeholder={input_object.label}
                          onChange={changeHandler}
                          disabled={locked}
                          required={required}
                          autoComplete="off"
                          {...attrs} />
          }
        }
        let labelCls = input_object.labelCls || ''
        if (required) {
          labelCls += ' required'
        }
        if (input_object.admin) {
          labelCls += ' admin'
        }
        if (input_object.user_lookup) {
          lookup_el = (
            <Select options={user_options}
                  styles={selectStyle}
                  placeholder="Enter email address to lookup user ID..."
                  onFocus={this.fetchUserOptions}
                  onChange={this.handleUserSelection.bind(this, input_object.name)} />
            )
        }
        let inline_instructions
        if (input_object.inline_instructions != null) {
          inline_instructions = <div className="instructions">{ input_object.inline_instructions }</div>
        }
        return (
          <div className="row inputRow" key={input_object.name}>
            <div className="col-sm-4 labelCol">
              <label className={labelCls} htmlFor={input_object.name} data-tip={input_object.instructions || ''} title={input_object.instructions || ''}>{ input_object.label }</label>
            </div>
            <div className="col-sm-8">
              { lookup_el }
              { input_el }
              { inline_instructions }
            </div>
          </div>
        )
      })
      return (
        <div className="InputGroup" key={input_group.name}>
          <h3>{ input_group.name }</h3>
          { inputs }
        </div>
      )
    })
  }

  handleMediaReorder(fromIndex, toIndex) {
    console.log(`Reorder ${fromIndex} -> ${toIndex}`)
    let {downloadable_media} = this.state
    const item = downloadable_media.splice(fromIndex, 1)[0];
    downloadable_media.splice(toIndex, 0, item)
    this.setState({downloadable_media})
  }

  getDMFileInput() {
    let dmInput = document.querySelector('[name=dm_file]')
    if (dmInput != null) {
      let files = dmInput.files
      console.log(files)
      if (files != null && files.length > 0) return files[0]
    }
    return null
  }

  uploadMediaToFirebase(e) {
    // For downloadable_media param only
    const UNIQUE_FILENAMES = false
    let {firebase} = this.props
    let {code, downloadable_media} = this.state
    const file = this.getDMFileInput()
    if (file != null) {
      const mimetype = file.type
      const metadata = { contentType: mimetype };
      let name = file.name;
      if (UNIQUE_FILENAMES) {
        let parts = name.split('.')
        let randomstring = Math.random().toString(36).slice(-4);
        // Add random string to make filename unique even if re-uploaded
        name = parts[0] + '-' + randomstring + '.' + parts[1]
      }
      this.setState({media_uploading: true}, () => {
        let sona_dir = firebase.storage_media_bucket.ref(code)
        const task = sona_dir.child(name).put(file, metadata);
        task
          .then(snapshot => {
            console.log(snapshot.ref)
            let url = snapshot.ref.bucket + '/' + snapshot.ref.fullPath
            console.log(url)
            downloadable_media.push({
              name: name,
              url: url,
              type: mimetype,
              description: ''
            })
            this.setState({downloadable_media: downloadable_media, media_uploading: false}, () => {
              this.dmFileInput.value = "" // Clear value
            })
          })
      })
    } else {
      toastr.error("No file selected")
    }
    e.preventDefault()
  }

  deleteMediaThumb(idx) {
    // Remove thumbnail from downloadable_media item and delete from storage
    let {firebase} = this.props
    let {code, downloadable_media} = this.state
    let dm = downloadable_media[idx]
    if (dm.thumb_url != null) {
      let splits = dm.thumb_url.split('/')
      let thumb_filename = splits[splits.length - 1]
      let sona_dir = firebase.storage_media_bucket.ref(code)
      const task = sona_dir.child(thumb_filename).delete().then(() => {
        // File deleted successfully
        toastr.success("Thumbnail deleted, you must still 'update' to save the SONA.")
        delete downloadable_media[idx].thumb_url
        this.setState({downloadable_media})
      }).catch((error) => {
        if (error.code_ === "storage/object-not-found") {
          delete downloadable_media[idx].thumb_url
          this.setState({downloadable_media})
        }
        // Uh-oh, an error occurred!
        console.error(error)
      });
    }
  }

  uploadCroppedMediaThumb(dm_id, media_key, e) {
    // Now goes through an API call on SONAD server to perform crop, and save to storage
    // For thumbnails for downloadable_media param only
    let {code, downloadable_media, localMultimediaData} = this.state
    let {dm_thumb_w, dm_thumb_h} = this.props
    let dm = downloadable_media[dm_id]
    let lm = localMultimediaData[media_key]
    const file = lm.file
    if (file != null) {
      const mimetype = file.type
      const metadata = { contentType: mimetype };
      // Use media filename, with 'thumb_' prefix and same extension as uploaded file
      let ext_re = /(?:\.([^.]+))?$/;
      let ext = ext_re.exec(file.name)[1];
      let original_ext = ext_re.exec(dm.name)[1];
      let original_no_ext = dm.name.replace('.' + original_ext, '')
      let filename = `thumb@x_${original_no_ext}`
      let full_filename = `${filename}.${ext}`;  // thumb@ prefix ensures cloud function we won't re-scale
      this.setState({media_uploading: true}, () => {
        let storage_destination = `sonad-media/${code}/${full_filename}`
        const formData  = new FormData();
        formData.append('auth', '5LgdMbRQacz5XMrhFCxR');
        formData.append('image_file', file);
        formData.append('file_type', ext);
        formData.append('filename', filename);
        formData.append('code', code);
        formData.append('crop', lm.crop != null ? lm.crop : "0,0,1,1");
        formData.append('out_size', `${dm_thumb_w},${dm_thumb_h}`);
        // let API_URL = 'http://localhost:8080/api/upload_image'
        let API_URL = 'https://firebase-sonad.appspot.com/api/upload_image'
        fetch(API_URL, {
          method: 'POST',
          body: formData
        }).then(response => response.json()).then(res => {
          console.log(res)
          if (res.success) {
            downloadable_media[dm_id].thumb_url = storage_destination
            toastr.success("Thumb uploaded, you must still 'update' to save the SONA.")
            this.setState({downloadable_media: downloadable_media, media_uploading: false, media_thumb_upload: null})
          }
        }).catch(
          error => console.log(error) // Handle the error response object
        );
      })
    } else {
      toastr.error("No file selected")
    }
    e.preventDefault()
  }

  getMediaDownloadUrl(gs_url) {
    let {firebase} = this.props
    let path_only = gs_url.replace('sonad-media/', '')
    let media_ref = firebase.storage_media_bucket.ref(path_only)
    console.log(media_ref.fullPath)
    media_ref.getDownloadURL().then(url => {
      window.open(url, '_blank')
    })
  }

  deleteMediaItem(dm, i) {
    // Remove item from downloadable_media list and delete from storage
    let {firebase} = this.props
    let {code, downloadable_media} = this.state
    let sona_dir = firebase.storage_media_bucket.ref(code)
    const task = sona_dir.child(dm.name).delete().then(() => {
      // File deleted successfully
      toastr.success("Media deleted, you must still 'update' to save the SONA.")
      downloadable_media.splice(i, 1)
      this.setState({downloadable_media: downloadable_media, media_thumb_upload: null})
    }).catch((error) => {
      if (error.code_ === "storage/object-not-found") {
        // Remove from SONA
        downloadable_media.splice(i, 1)
        this.setState({downloadable_media})
      }
      // Uh-oh, an error occurred!
      console.error(error)
    });
  }

  showMediaThumbUpload(idx) {
    this.setState({media_thumb_upload: idx})
  }

  renderDownloadableMediaSection() {
    let {admin, firebase, dm_thumb_w, dm_thumb_h} = this.props
    let {localMultimediaData, downloadable_media, userId, ownerCanManageMedia, media_uploading, media_thumb_upload} = this.state
    let content
    let n = downloadable_media.length
    let owner = userId === firebase.get_uid()
    let permission_to_manage = admin || (owner && ownerCanManageMedia === 'Yes')
    if (permission_to_manage) {
      if (this.editing()) {
        let loader
        if (media_uploading) loader = <Loader />
        let dm_file_selected = localMultimediaData["dm_file"] != null && localMultimediaData["dm_file"].file != null
        let upload_disabled = media_uploading || !dm_file_selected
        content = (
          <div>
            <ReactDragListView nodeSelector='li' handleSelector='.handle' onDragEnd={this.handleMediaReorder}>
            <ul className="DownloadableMediaList">
              { downloadable_media.map((dm, i) => {
                let _thumb, _thumb_upload
                if (dm.thumb_url != null) {
                  _thumb = (<span>
                    Custom thumbnail uploaded<br/>
                    <a href="javascript:void(0)" onClick={this.showMediaThumbUpload.bind(this, i)}>Replace thumbnail</a> or&nbsp;
                    <a href="javascript:void(0)" onClick={this.deleteMediaThumb.bind(this, i)}>Delete thumbnail</a>
                    </span>
                    )
                } else {
                  _thumb = <a href="javascript:void(0)" onClick={this.showMediaThumbUpload.bind(this, i)}>Upload thumbnail</a>
                }
                if (media_thumb_upload != null && media_thumb_upload == i) {
                  let media_key = `dm_${i}_thumb`
                  let localData = localMultimediaData[media_key]
                  let _cropper
                  if (localData != null) _cropper = (
                    <FirebaseImageCropper image_data={localData.data}
                                          prop={media_key}
                                          width={dm_thumb_w}
                                          height={dm_thumb_h}
                                          borderRadius={0}
                                          file={localData.file}
                                          cropChange={this.cropChange} />
                  )
                  _thumb_upload = (
                    <div>
                      <span>Please select a PNG or JPG to serve as a thumbnail for this media item.</span>
                      { _cropper }
                      <input type="file" name={media_key} onChange={this.onImageSelected} />
                      <button type="button" onClick={this.uploadCroppedMediaThumb.bind(this, i, media_key)} style={{color: 'black'}} disabled={media_uploading}>Upload Thumbnail</button>
                    </div>
                    )
                }
                return (
                  <li key={i}>
                    <i className="fa fa-bars handle" title="Drag to re-order"></i>
                    <a href="javascript:void(0)" onClick={this.getMediaDownloadUrl.bind(this, dm.url)} target="_blank" className="MediaTitle">{ dm.name || "Media item" } ({dm.type})</a>
                    <span className="Delete"><a href="javascript:void(0)" onClick={this.deleteMediaItem.bind(this, dm, i)}><i className="fa fa-trash"></i> Delete</a></span>
                    <div className="Thumb">
                    { _thumb }
                    { _thumb_upload }
                    </div>
                  </li>
                  )
              })}
            </ul>
            </ReactDragListView>

            <div>
              <h4><i className="fa fa-plus"></i> Upload new media item</h4>

              <input type="file" name="dm_file" ref={ref=> this.dmFileInput = ref} onChange={this.onDMImageSelected} />

              { loader }
              <button type="button" onClick={this.uploadMediaToFirebase} style={{color: 'black'}} disabled={upload_disabled}>Upload</button>

            </div>
          </div>
        )
      } else {
        content = <p>To upload downloadable media, please first save the SONA, then come back to this page for editing.</p>
      }
      return (
        <div className="InputGroup" style={{marginBottom: 50}}>
          <h3>Downloadable Media: {n} media item(s)</h3>
          { content }
        </div>
      )
    }
  }

  editing() {
    let {edit_sona_id} = this.props
    return edit_sona_id != null
  }

  render() {
    let {error, ABOUT_ME, saving, name, sona_id_ok} = this.state
    let action = this.editing() ? "Update" : "Create"
    let about_me_audio, share_sec
    if (this.editing() && ABOUT_ME != null && ABOUT_ME.length > 0) {
      about_me_audio = (
        <div>
          <label>User Audio With Barcode</label><br/>
          <audio controls="download" src={this.gcsUrl(ABOUT_ME)} />
          <br/>To download:<br/><a href={this.gcsUrl(ABOUT_ME)} download="ABOUT_ME.wav">Right-click and choose "Save..." or "Download..."</a>
        </div>
      )
    }
    if (this.editing()) {
      let url = this.universalShareURL()
      let body = encodeURIComponent(`SONAD: Check out "${name}" at ${url}`)
      let subject = encodeURIComponent(`SONAD: Check out "${name}"`)
      let mailto = `mailto:?body=${body}&subject=${subject}`
      share_sec = <p>Share SONA:<br/><a href={mailto} target="_blank"><img src={process.env.PUBLIC_URL + "/img/share.png"} width="50" height="50" alt="Share SONA"/></a></p>
    }
    return (
      <div className="container">
        <form onSubmit={this.onSubmit} className="Sonad-form Create-form" autoComplete="off">

          { this.renderInputRows() }

          { this.renderDownloadableMediaSection() }

          {error && <p>{error.message}</p>}

          <button type="submit" disabled={saving || !sona_id_ok}>{ action }</button>
          { saving ? <p><Loader /> Saving...</p> : null }

          { about_me_audio }

          <p><br/>Generate and download QR code:<br/><a href={this.generateQRCodeURL()} target="_blank" download="QR.png">Click here, or right click and choose "Save as..."</a></p>

          { share_sec }
        </form>
      </div>
    );
  }
}

const FirebaseImageCropper = compose(
  withFirebase,
)(ImageCropper);


CreateEditFormBase.defaultProps = {
  edit_sona_id: null,
  admin: false,
  // Sync with functions/index.ts/generateThumbs
  dm_thumb_w: 640,
  dm_thumb_h: 360
}